import { useCallback, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

/** Tour tab changes replace history and restore the user's original filters on exit. */
export function useTourNavigation() {
  const [params, setParams] = useSearchParams();
  const original = useRef(params.toString());
  const [activeStep, setActiveStep] = useState<string | null>(null);
  const current = useRef(params);
  current.current = params;
  const onStart = useCallback(() => {
    original.current = current.current.toString();
  }, []);
  const onNavigate = useCallback(
    (step: { id: string; tab?: string; query?: Record<string, string> }) => {
      setActiveStep(step.id);
      const next = new URLSearchParams(current.current);
      if (step.tab) next.set('tab', step.tab);
      Object.entries(step.query ?? {}).forEach(([key, value]) => next.set(key, value));
      if (next.toString() !== current.current.toString()) setParams(next, { replace: true });
    },
    [setParams],
  );
  const onEnd = useCallback(() => {
    setActiveStep(null);
    setParams(new URLSearchParams(original.current), { replace: true });
  }, [setParams]);
  return { tourNavigation: { onStart, onNavigate, onEnd }, activeStep };
}
